export const summary = {
  data() {
    return {
      summary: [
        {
          type: "month",
          course: 24,
          time: 120,
          exam: 18,
        },
        {
          type: "week",
          course: 36,
          time: 260,
          exam: 26,
        },
        {
          type: "year",
          course: 68,
          time: 320,
          exam: 38,
        }
      ],
    }
  },
}